import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { TfiReload } from "react-icons/tfi";
import { LoginContext } from "../../../context/LoginContext";
import { Link, useNavigate } from "react-router-dom"
import NoDataImage from "../../../background.gif";




const FilterCardGallery = () => {

  const { isLoggedIn, userId, userName, userData, isPremium } = useContext(LoginContext);
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("desiredPartners");
  const [recentlyUsers, setrecentlyUsers] = useState([]);
  const [matchedUser, setmatchedUser] = useState([]);
  const [interestUsers, setinterestUsers] = useState([]);
  const [desiredUsers, setdesiredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState({ start: 0, end: 8 });
  const [matched, setmatched] = useState({ start: 0, end: 8 });
  const [interest, setinterest] = useState({ start: 0, end: 8 });
  const [desired, setdesired] = useState({ start: 0, end: 8 });


  // fetchMatched();

  useEffect(() => {

    if (!isLoggedIn) {
      navigate("/login");
    }

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);

    const fetchUsers = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}mycon/recently_joint_match`, payload
        );
        if (response.data.recently) setrecentlyUsers(response.data.recently);
        else setrecentlyUsers([]);
      } catch (error) {
        console.error("There was an error fetching users!", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchDesired = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}mycon/desire_patner_match`, payload
        );
        if (response.data.matched) setdesiredUsers(response.data.matched);
        else setdesiredUsers([]);
      } catch (error) {
        console.error("There was an error fetching users!", error);
      }
    };

    const fetchInterest = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}mycon/send_interest`, payload
        );
        if (response.data.connection) setinterestUsers(response.data.connection);
        else setinterestUsers([]);

      } catch (error) {
        console.error("There was an error fetching users!", error);
      }
    };

    const fetchMatched = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}mycon/matched_interest`, payload
        );
        if (response.data.matched) setmatchedUser(response.data.matched);
        else setmatchedUser([]);

      } catch (error) {
        console.error("There was an error fetching users!", error);
      }
    };

    fetchDesired();
    fetchInterest();
    fetchUsers();
    fetchMatched();
  }, []);

  // Calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  // Format height (5.6 => 5'6")
  const formatHeight = (height) => {
    if (!height) return "N/A";
    const [feet, inches] = height.split(".");
    return `${feet}'${inches}"`;
  };

  const handleLoadMore = (data, setdata, api) => {
    setdata({ start: 0, end: (data.end + 8) });
    if ((data.end) > (api.length - 1)) {
      setdata({ start: 0, end: (api.length) });
    }
  };


  // Filter users based on active filter
  const filterData = {
    desiredPartners: desiredUsers.slice(desired.start, desired.end), // Assuming a matched property exists
    recentlyJoined: recentlyUsers.slice(load.start, load.end), // First 8 as recently joined
    matchedProfiles: matchedUser.slice(matched.start, matched.end), // Assuming a matched property exists
    recentlySentInterest: interestUsers.slice(interest.start, interest.end), // Last 8 as recently sent interest
  };

  return (
    <div className="filter-card-gallery">
      <div className="content-wrapper">
        <div className="filter-buttons justify-content">

          <button
            className={activeFilter === "desiredPartners" ? "active" : ""}
            onClick={() => setActiveFilter("desiredPartners")}
          >
            Desired Partner
          </button>
          <button
            className={activeFilter === "matchedProfiles" ? "active" : ""}
            onClick={() => setActiveFilter("matchedProfiles")}
          >
            Matched Profiles
          </button>
          <button
            className={activeFilter === "recentlySentInterest" ? "active" : ""}
            onClick={() => setActiveFilter("recentlySentInterest")}
          >
            Sent Interest
          </button>
          <button
            className={activeFilter === "recentlyJoined" ? "active" : ""}
            onClick={() => setActiveFilter("recentlyJoined")}
          >
            Recently Joined
          </button>
        </div>

        {loading ? (
          <div className='custom-loader-g'><div class="spinner-border text-danger" role="status"><span class="sr-only">Loading...</span></div></div>)
          : (<div className="cards-grid" style={{ display: (Object.keys(filterData[activeFilter]).length < 1) ? ("block") : "grid" }} >
            {filterData[activeFilter].map((member) => (
              <Link   to={isPremium?`/view-profile/${member.user_id}`:`/upgrade/${userId}`} style={{ color: 'white' }} key={member.user_id} className="member-card">
                <img
                  // src={`http://localhost/perfomdigi/hindu-humsfar-react/backend/${member.image1}`}
                  // alt={member.name}
                  // onError={(e) => {
                  //   e.target.src = "./default.webp";
                  //   e.target.onerror = null;
                  // }}
                  src={
                    member.image1
                      ? `${process.env.REACT_APP_API_BASE_URL}${member.image1}`
                      : "/default.jpg"
                  }
                  alt={member.name}
                  onError={(e) => {
                    e.target.src = "/default.jpg";
                    e.target.onerror = null;
                  }}
                  className="member-image"
                />
                <div className="member-info">
                  <h5> {member.name}</h5>
                  <div className="member-id-gender">
                    <span className="member-id">
                      {member.gender === "male"
                        ? "M"
                        : member.gender === "female"
                          ? "F"
                          : ""}
                    </span>
                    <span className="member-id">HS{member.user_id}</span>
                  </div>

                  <div className="member-details" >
                    <div className="detail-row">
                      <span className="detail-label">Age:</span>
                      <span className="detail-value">
                        {calculateAge(member.dob)} Yrs
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Height:</span>
                      <span className="detail-value">
                        {formatHeight(member.height)}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Gender:</span>
                      <span className="detail-value">
                        {member.gender}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Caste:</span>
                      <span className="detail-value">
                        {member.caste || "N/A"}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Location:</span>
                      <span className="detail-value">
                        {member.curr_location || member.country || "India"}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
            {(Object.keys(filterData[activeFilter]).length < 1) ? (<div className='position-relative nodataBox w-100 h-100' style={{ backgroundImage: `url(${NoDataImage})` }}><div><h2 className={'text-white fw-bold text-center'}>No Match Found</h2></div></div>) : ""}
          </div>
          )}


        {(activeFilter === "desiredPartners") && (desiredUsers.length > 8 && desired.end != desiredUsers.length) && <p className="text-center">
          <button onClick={() => handleLoadMore(desired, setdesired, desiredUsers)} className="btn btn-outline-danger"> <TfiReload /> Load More Desired Profiles</button>
        </p>}

        {(activeFilter === "recentlyJoined") && (recentlyUsers.length > 8 && load.end != recentlyUsers.length) && <p className="text-center">
          <button onClick={() => handleLoadMore(load, setLoad, recentlyUsers)} className="btn btn-outline-danger"> <TfiReload /> Load More Profiles</button>
        </p>}


        {(activeFilter === "matchedProfiles") && (matchedUser.length > 8 && matched.end != matchedUser.length) && <p className="text-center">
          <button onClick={() => handleLoadMore(matched, setmatched, matchedUser)} className="btn btn-outline-danger"> <TfiReload /> Load More Matched Profiles</button>
        </p>}

        {(activeFilter === "recentlySentInterest") && (interestUsers.length > 8 && interest.end != interestUsers.length) && <p className="text-center">
          <button onClick={() => handleLoadMore(interest, setinterest, interestUsers)} className="btn btn-outline-danger"> <TfiReload /> Load More recently Sent Interest</button>
        </p>}


        {/* <a href="" className="load-more">
          <TfiReload /> Load More Profiles
        </a> */}
      </div>

      <style jsx>{`

      button,section,div,p,h5,span{
      text-transform:capitalize;
      }

        .member-info h5,
        .member-id {
          color: white !important;
          text-align: center !important;
        }
        .member-info {
          text-align: center !important;
        }
        .detail-label {
          color: white !important;
        }
        .detail-value {
          color: white !important;
        }
        .filter-card-gallery {
          padding: 60px 20px;
          background: #fff;
        }

        .content-wrapper {
          max-width: 1200px;
          margin: 0 auto;
        }

        .filter-buttons {
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
          border-bottom: 1px solid #eee;
          gap: 20px;
        }

        .filter-buttons button {
          background: none;
          border: 1px solid #e53d5c;
          border-radius:10px;
          padding: 10px 20px;
          cursor: pointer;
          font-size: 16px;
          color: #e53d5c;
          position: relative;
          transition: all 0.3s ease;
        }

        .filter-buttons button:hover {
          color: #e53d5c;
        }

        .filter-buttons button.active {
        color:white;
          background: #e53d5c;
          font-weight: bold;
        }

        .filter-buttons button.active::after {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: #e53d5c;
        }

        .cards-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
          margin-bottom: 30px;
        }

        .member-card {
          background: white;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }

        .member-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        }

        .member-image {
          width: 100%;
          height: 250px;
          object-fit: cover;
          display: block;
        }

        .member-info {
          background: #e53d5c;
          color: white;
          padding: 15px;
        }

        .member-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          justify-content: center;
        }

        .gender-badge {
          background: white;
          color: #e53d5c;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 14px;
        }

        .member-id {
          font-weight: bold;
          color: white;
        }

        .member-details {
          font-size: 13px;
        }

        .detail-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
          padding-bottom: 5px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .detail-row:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .detail-row span:first-child {
          font-weight: 500;
        }

        .load-more {
          display: block;
          text-align: center;
          color: black;
          font-size: 16px;
          text-decoration: none;
          font-weight: bold;
          margin-top: 30px;
          transition: color 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .load-more:hover {
          color: #e53d5c;
          text-decoration: underline;
        }

        .loading {
          text-align: center;
          padding: 50px;
          color: #666;
        }

        @media (max-width: 1024px) {
          .cards-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .member-details {
            font-size: 12px;
          }
        }

        @media (max-width: 768px) {
          .cards-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .filter-buttons {
            gap: 10px;
          }

          .filter-buttons button {
            padding: 8px 12px;
            font-size: 14px;
            border: 1px solid #e53d5c;
            border-radius: 10px;
            color:#e53d5c;
          }
        }

        @media (max-width: 480px) {
          .filter-card-gallery {
            padding: 40px 15px;
          }

          .cards-grid {
            grid-template-columns: 1fr;
          }

          .member-details {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default FilterCardGallery;
